/**
 * api接口统一管理
 * by fengyang
 */
import {
    post,
    get,
    Header,
    postLogin,
    postFormData,
    del,
    getImg,
    getBlob
} from './http';
// 上传
export const upload = formData => postFormData(Header.client + '/file/upload', formData)

// 查询省份
export const nation = pid => get(Header.client + `/dic/nation/${pid}`)

// 下拉菜单
export const selectDic = dicCodeStr => get(Header.client + `/dic/data/${dicCodeStr}`);

// 添加管理机构
export const addMgr = params => post(Header.client + `/institution/addMgr`, params);

// 变更管理机构
export const upMgr = params => post(Header.client + `/institution/updateMgrBasic`, params);

// 根据code获取出资人 
export const getInvestor = code => get(Header.client + `/institution/investors/${code}`);

// 根据id获取出资人 
export const getInvestorDetail = id => get(Header.client + `/institution/investorsDetail/${id}`);

// 根据id删除出资人 
export const delInvestor = id => get(Header.client + `/institution/deleteInvestor/${id}`);

// 添加出资人
export const addInvestor = params => post(Header.client + `/institution/addInvestor`, params);
// 添加出资人
export const updataInvestor = params => post(Header.client + `/institution/updateInvestor`, params);

export const addUpInvestor = (flag, params) => {
    if (flag.includes('添加')) {
        return addInvestor(params)
    } else return updataInvestor(params)
}
//删除机构信息
export const delMessage = institutionCode => del(Header.client + `/institution/inst/${institutionCode}`);

// GLQR1565835539895

// 根据code获取联系人 法人..
export const getPersons = code => get(Header.client + `/institution/getPersons/${code}`);

// // 添加联系人/财务负责人
// export const addContactFin = params => post(Header.client + `/institution/addFinanceLinkman`, params);

// // 变更联系人/财务负责人
// export const upContactFin = params => post(Header.client + `/institution/updateFinanceLinkman`, params);

// export const addUpContactFin = (flag, params) => {
//     if (flag.includes('添加')) {
//         return addContactFin(params)
//     } else return upContactFin(params)
// }

// 根据id删除联系人
// const delContactFin = ids => get(Header.client + `/institution/financelinkmanDel/${ids}`);

// const delLegal = ids => get(Header.client + `/institution/legalRiskmanDel/${ids}`);

// export const delStep3 = (flag, ids) => {
//     if (['1', '4'].includes(flag)) {
//         return delContactFin(ids)
//     } else return delLegal(ids)
// }


// 添加法定代表..
const addLegalR = params => post(Header.client + `/institution/addLegalRiskman`, params);

// 变更法定代表..
const upLegalR = params => post(Header.client + `/institution/updateLegalRiskman`, params);

export const addUpLegalR = (flag, params) => {
    if (flag.includes('添加')) {
        return addLegalR(params)
    } else return upLegalR(params)
}

// 根据id获取法人 合规风控 
export const getLegalDetail = id => get(Header.client + `/institution/legalRiskmanDetail/${id}`);

// 联系人详情
export const financeLinkmanDetail = id => get(Header.client + `/institution/financeLinkmanDetail/${id}`);

// 添加其他信息
export const addOtherInfo = params => post(Header.client + `/institution/addOtherInfo`, params);

// 变更其他信息
const upOtherInfo = params => post(Header.client + `/institution/updateOtherInfo`, params);

// export const addUpOtherInfo = (flag, params) => {
//     if (flag.includes('添加')) {
//         return addContactFin(params)
//     } else return upContactFin(params)
// }

// 获取基金管理机构 基金机构列表
export const getFundList = params => post(Header.client + `/institution/page`, params);

// 获取基金管理机构详细信息
export const getDetailMgr = institutionCode => get(Header.client + `/institution/detailMgr/${institutionCode}`);

// 获取基金机构详细信息
export const getDetailAgency = institutionCode => get(Header.client + `/institution/detailFund/${institutionCode}`);

export const getDetailAorManager = (flag, institutionCode) => {
    if (flag.includes('Management')) return getDetailMgr(institutionCode);
    else return getDetailAgency(institutionCode)
}

// 提交审核信息
export const submitMgr = institutionCode => get(Header.client + `/checkRecord/submit/${institutionCode}`);


// 添加变更管理机构
export const addUpMgr = (flag, params) => {
    if (flag == 'update') {
        return upMgr(params)
    } else return addMgr(params)
}

// 添加机构
export const addAgency = params => post(Header.client + `/institution/addfund`, params);
// 变更机构
export const upAgency = params => post(Header.client + `/institution/updateFundBasic`, params);

// 添加变更机构
export const addUpAgency = (flag, params) => {
    if (flag == 'update') {
        return upAgency(params)
    } else return addAgency(params)
}


// 季报

// 查询季报状态
export const initReport = institutionCode => get(Header.client + `/quarterReport/init/${institutionCode}`);

// 获取季报列表
export const getReportList = params => post(Header.client + `/quarterReport/reportList`, params);

// 新增-变更基本信息
export const updateRecordBasic = params => post(Header.client + `/quarterReport/updateBasic`, params);

// 填写季报获取季报详情
export const getReportDetail = reportCode => get(Header.client + `/quarterReport/reportDetail/${reportCode}`);

//获取已发行产品基金信息列表
export const getFund = reportCode => get(Header.client + `/quarterReport/mgrFundList/${reportCode}`)
// 获取已发行产品信息列表
export const getProduct = fundId => get(Header.client + `/quarterReport/productList/${fundId}`);


// 新增已发行产品信息
export const addProduct = params => post(Header.client + `/quarterReport/addProduct`, params);
//新增基金已发行产品
export const addFund = params => post(Header.client + `/quarterReport/addMgrfund`, params)

// 修改基金已发行产品
export const updateFund = params => post(Header.client + `/quarterReport/updateMgrFund`, params)
//修改已发行产品信息
export const updateProduct = params => post(Header.client + `/quarterReport/updateProduct`, params);
// 删除产品
export const delProduct = idStr => del(Header.client + `/quarterReport/product/${idStr}`);
//删除已发行产品基金信息列表
export const delFund = idStr => del(Header.client + `/quarterReport/mgrFund/${idStr}`)

//获取季报企业名称
export const repeitName = identifyCode => get(Header.client + `/quarterReport/institutions/${identifyCode}`)


// 添加变更机构
export const addUpProduct = (flag, params) => {
    if (flag.includes('编辑')) {
        return updateFund(params)
    } else return addFund(params)
}

// 添加已发行产品信息
export const addUpdateMes = (flag, params) => {
    if (flag.includes('编辑')) {
        return updateProduct(params)
    } else return addProduct(params)
}

// 获取拟发行产品
export const getPreProduct = code => get(Header.client + `/quarterReport/preProductList/${code}`);

// 新增已发行产品
export const addPreProduct = params => post(Header.client + `/quarterReport/addPreProduct`, params);
// 变更
export const updatePreProduct = params => post(Header.client + `/quarterReport/updatePreProduct`, params);
// // 删除产品
export const delPreProduct = id => del(Header.client + `/quarterReport/preProduct/${id}`);


// // 添加变更机构
export const addUpPreProduct = (flag, params) => {
    if (flag.includes('编辑')) {
        return updatePreProduct(params)
    } else return addPreProduct(params)
}

// 获取企业重大变更
export const getCompany = code => get(Header.client + `/quarterReport/largeChange/${code}`);

// 新增已发行产品
export const addCompany = params => post(Header.client + `/quarterReport/addChange`, params);

// 变更
export const updateCompany = params => post(Header.client + `/quarterReport/updateLargeChange`, params);

// 删除产品
export const delCompany = id => del(Header.client + `/quarterReport/deleteLargeChange/${id}`);


// // 添加变更机构
export const addUpCompany = (flag, params) => {
    if (flag.includes('编辑')) {
        return updateCompany(params)
    } else return addCompany(params)
}

// // 季报信息表保存
// export const reportFileSave = params => get(Header.client + `/quarterReport/reportFileSave`, params);

// 变更基金机构已投向情况
export const updateFundInvested = params => post(Header.client + `/quarterReport/updateInvested`, params);

// 获取基金机构已投向情况
export const getFundInvested = reportCode => get(Header.client + `/quarterReport/fundInvested/${reportCode}`);

// 新增已发行产品
export const addFundInveste = params => post(Header.client + `/quarterReport/addInvested`, params);

// 变更
export const updateFundInveste = params => post(Header.client + `/quarterReport/updateInvested`, params);

// 删除产品
export const delFundInveste = id => del(Header.client + `/quarterReport/fundInvested/${id}`);


// // 添加变更机构
export const addUpFundInveste = (flag, params) => {
    if (flag.includes('编辑')) {
        return updateFundInveste(params)
    } else return addFundInveste(params)
}

// 获取基金机构新增投资
export const getFundNewInvested = reportCode => get(Header.client + `/quarterReport/fundPreInvesteList/${reportCode}`);

// 新增已发行产品
export const addFundNewInveste = params => post(Header.client + `/quarterReport/addPreInveste`, params);

// 变更
export const updateFundNewInveste = params => post(Header.client + `/quarterReport/updatePreInveste`, params);

// 删除产品
export const delFundNewInveste = id => del(Header.client + `/quarterReport/fundPreInveste/${id}`);


// // 添加变更机构
export const addUpFundNewInveste = (flag, params) => {
    if (flag.includes('编辑')) {
        return updateFundNewInveste(params)
    } else return addFundNewInveste(params)
}

// 下载信息表
export const downloadInfo = reportCode => {
    location.href = Header.download + `/quarterReport/reportExport/${reportCode}`
}

// //提交季报
// export const submitReport = reportCode => get(Header.client + `/quarterReport/submit/${reportCode}`);

// 审核
export const checkRecord = params => post(Header.client + `/checkRecord/page`, params);

// 用户相关
export const userDetail = code => get(Header.client + `/userInstition/detail/${code}`);

// 更新用户
export const userUpdate = params => post(Header.client + '/userInstition/update', params);


// 注册账户

/* 1-1 机构注册 */
export const ApiRegister = params => post(Header.client + "/index/register", params)

/* 1-2 发送手机验证码 */
export const ApiTelCode = params => get(Header.client + `/code/telCode/${params.tel}`)


/* 图形验证码 */
export const ApiImagecode = params => getImg(Header.client + "/code/image", params)

/* 用户登录 密码登录 */
export const ApipasswordLogin = params => postLogin(Header.client + "/index/login", params)

/* 用户登录 手机登录 */
export const ApiPhoneLogin = params => postLogin(Header.client + "/index/login", params)

/* 用户登录  重置密码 */
export const ApiResetPwd = params => post(Header.client + "/index/resetPwd", params)


// 举报前台
export const getPreReportList = params => post(Header.client + '/report/list', params);

// 发起举报
export const addReport = params => post(Header.client + "/report/add", params);


// 举报详情
export const reportDetail = id => get(Header.client + `/report/reportDetail/${id}`);

// 消息
export const getNoticeInfo = params => post(Header.client + `/notice/page`, params);

// 未读消息数量
export const getNoticeCount = userCode => get(Header.client + `/notice/unRead/${userCode}`);

// 消息详情
export const getNoticeDetail = id => get(Header.client + `/notice/detail/${id}`);

// 信息公示
export const townPublicity = params => post(Header.client + "/town/publicity", params);

// 修改密码
export const editPsd = params => post(Header.client + "/index/alertPwd", params);

// 小镇相关
export const townServiceList = itemName => get(Header.client + `/town/service/${itemName}`)

// 下载信息表
export const downloadTownInfo = id => {
    location.href = Header.download + `/town/download/service/${id}`
}
// 公用下载接口
export const downLoadCommon = (dir, suffix, orign, store) => {
    location.href = Header.download + `/file/download/${dir}/${suffix}/${orign}/${store}`
}

// 机构信息下载相关接口
export const institutionDownLoadCommon = params => {
    location.href = Header.download + `/institution/download?filePath=${params.filePath}&fileName=${params.fileName}`//可以使用 Request URL显示为localhost:18010
    // location.href = Header.client + `/institution/download?filePath=${params.filePath}&fileName=${params.fileName}`//可以使用 Request URL显示为localhost:18010
    // get(Header.client + `/institution/download`, params)  //不可以使用 服务器错误，状态码undefined Request URL显示为localhost:9000 response项中有文件数据返回
    // get(Header.download + `/institution/download`, params)  //不可以使用  403错误代码【Invalid CORS request】  Request URL显示为localhost:18010
    // post(Header.download + `/institution/download?filePath=${params.filePath}&fileName=${params.fileName}`, null,'application/x-www-form-urlencoded')  //不可以使用  403错误代码【Invalid CORS request】  Request URL显示为localhost:18010
    // post(Header.download + `/institution/download`, params,'application/x-www-form-urlencoded')  //不可以使用  403错误代码【Invalid CORS request】  Request URL显示为localhost:18010
    // post(Header.client + `/institution/download`, params,'application/x-www-form-urlencoded')  //不可以使用 后台报错Required String parameter 'filePath' is not present Request URL显示为localhost:9000
    // post(Header.download + `/institution/download`, params)  //不可以使用  403错误代码【Invalid CORS request】  Request URL显示为localhost:18010
}
//获取服务机构所有数据
export const agencyList = () => get(Header.client + `/town/agency/list`);

//获取服务机构详情
export const logoDetail = id => get(Header.client + `/town/agency/${id}`);

//获取小镇相关信息
export const getAgencyList = () => get(Header.client + `/town/info`);

//获取所有基金小镇(根据地址)
export const getAllTownList = () => get(Header.client + `/Address/getFundTownLike`);

//获取所有基金小镇
export const getTownBaiscList = () => get(Header.client + `/basicInfo/getAll`);

//获取所有页面图片和网址配置
export const getPageConfigListMain = params => get(Header.client + `pageConfig/getMainList`, params);
//获取小镇页面配置
export const getPageConfigList = params => get(Header.client + `pageConfig/getDesList`, params);

//添加出资人信息
// export const addInvestor = params => post(Header.client + `institution/addInvestor`, params);

//添加人员信息
export const addPersonInfo = params => post(Header.client + `institution/addPersonInfo`, params);

//变更人员信息
export const updateFinanceLinkman = params => post(Header.client + `institution/updateFinanceLinkman`, params);


// 根据id删除联系人
export const delStep3 = ids => get(Header.client + `institution/legalRiskmanDel/${ids}`);

//根据机构代码获取其他信息
export const getOtherInfo = institutionCode => get(Header.client + `institution/getOtherInfo/${institutionCode}`);

//单文件文件上传
export const singleUpload = formData => postFormData(Header.client + `institution/singleUpload`, formData);

//根据id获取人员信息详情
export const personInfoDetail = id => get(Header.client + `/institution/institutionPersonInfoDetail/${id}`);



//保存季报基本信息
export const saveReportBasic = params => post(Header.client + `/quarterReport/saveReportBasic`, params);

//保存季报基金信息
export const saveReportMgrFund = params => post(Header.client + `/quarterReport/saveReportMgrFund`, params);

// 保存季报 fund_invested
export const saveReportFundInvested = params => post(Header.client + `/quarterReport/saveReportFundInvested`, params);

// @ApiOperation(value = "保存季报 fund_assets", notes = "保存季报 证券_资产信息")
// @PostMapping("saveReportFundAssets")
export const saveReportFundAssets = params => post(Header.client + `/quarterReport/saveReportFundAssets`, params);

// 保存季报 mgr_product", notes = "保存季报 mgr_product 发行产品"
export const saveReportMgrProduct = params => post(Header.client + `/quarterReport/saveReportMgrProduct`, params);

// @ApiOperation(value = "保存季报 large_change", notes = "保存季报 重大事项变更")
export const saveReportLargeChange = params => post(Header.client + `/quarterReport/saveReportLargeChange`, params);

// @ApiOperation(value = "机构季报-提交", notes = "机构季报-修改check_record表记录的状态")
// @GetMapping("submit/{reportCode}")
//提交季报
export const submitReport = reportCode => get(Header.client + `/quarterReport/submit/${reportCode}`);

// @ApiOperation(value = "更新单个 mgr_fund", notes = "更新单个 基金信息/FOF子基金信息")
export const updateMgrFund = params => post(Header.client + `/quarterReport/updateMgrFund`, params);

// @ApiOperation(value = "更新单个 fund_invested", notes = "更新单个 底层投资信息")
export const updateFundInvestedNew = params => post(Header.client + `/quarterReport/updateFundInvested`, params);

// @ApiOperation(value = "更新单个 fund_assets", notes = "更新单个 持有资产")
export const updateFundAssets = params => post(Header.client + `/quarterReport/updateFundAssets`, params);

// @ApiOperation(value = "更新单个 mgr_product", notes = "更新单个 发行产品")
export const updateMgrProduct = params => post(Header.client + `/quarterReport/updateMgrProduct`, params);

// @ApiOperation(value = "删除 mgr_fund", notes = "删除 基金信息/FOF子基金信息")
// @PostMapping("deleteMgrFund/{ids}")
export const deleteMgrFund = id => post(Header.client + `/quarterReport/deleteMgrFund/${id}`);

// @ApiOperation(value = "删除 fund_invested", notes = "删除 底层投资信息")
// @PostMapping("deleteFundInvested/{ids}")
export const deleteFundInvested = id => post(Header.client + `/quarterReport/deleteFundInvested/${id}`);

// @ApiOperation(value = "删除 fund_assets", notes = "删除 持有资产信息")
// @PostMapping("deleteFundAssets/{ids}")
export const deleteFundAssets = id => post(Header.client + `/quarterReport/deleteFundAssets/${id}`);


// @ApiOperation(value = "删除 mgr_product", notes = "删除 发行产品信息")
// @PostMapping("deleteMgrProduct/{ids}")
export const deleteMgrProduct = id => post(Header.client + `/quarterReport/deleteMgrProduct/${id}`);


// @ApiOperation(value = "获取季报基本信息 baisc", notes = "获取季报基本信息 基本信息")
// @GetMapping("getReportBasicByReportCode")
export const getReportBasicByReportCode = params => get(Header.client + `/quarterReport/getReportBasicByReportCode/`, params);


// @ApiOperation(value = "获取季报基金和子基金 mgr_fund", notes = "获取季报基金和子基金 mgr_fund")
// @GetMapping("getReportMgrFundByReportCode")
export const getReportMgrFundByReportCode = params => get(Header.client + `/quarterReport/getReportMgrFundByReportCode/`, params);

// @ApiOperation(value = "单独获取季报子基金 mgr_fund", notes = "单独获取季报子基金 mgr_fund")
// @GetMapping("getReportMgrFundByReportCode/{id}")
export const getReportMgrFundByReportCodeSub = id => get(Header.client + `/quarterReport/getReportMgrFundByReportCode/${id}`);


// @ApiOperation(value = "获取季报持有资产 fund_assets", notes = "zq 获取季报持有资产 fund_assets")
// @GetMapping("getReportFundAssetsByReportCode")
export const getReportFundAssetsByReportCode = params => get(Header.client + `/quarterReport/getReportFundAssetsByReportCode/`, params);

// @ApiOperation(value = "获取季报底层投资 fund_invested", notes = "gq y获取季报底层投资 fund_invested")
// @GetMapping("getReportFundInvestedByReportCode")
export const getReportFundInvestedByReportCode = params => get(Header.client + `/quarterReport/getReportFundInvestedByReportCode/`, params);

// @ApiOperation(value = "获取季报产品信息 mgr_product", notes = "x 获取季报产品信息 mgr_product")
// @GetMapping("getReportMgrProductByReportCode")
export const getReportMgrProductByReportCode = params => get(Header.client + `/quarterReport/getReportMgrProductByReportCode/`, params);

// @ApiOperation(value = "获取季报产品信息 large_change", notes = "获取季报重大事项变更 large_change")
// @GetMapping("getReportLargeChangeByReportCode/{reportCode}")
export const getReportLargeChangeByReportCode = reportCode => get(Header.client + `/quarterReport/getReportLargeChangeByReportCode/${reportCode}`);

// @ApiOperation(value = "机构季报-季报详情", notes = "机构季报-季报详情(基金管理机构季报与基金机构季报数据不同)")
// @GetMapping("reportDetail/{reportCode}")
export const quarterReportReportDetail = reportCode => get(Header.client + `/quarterReport/reportDetail/${reportCode}`);


// @ApiOperation(value = "机构季报-季报详情信息表导出", notes = "机构季报-季报详情信息表导出")
// @GetMapping("reportExport/{reportCode}")
export const reportExport = reportCode => {
    location.href = Header.download + `/quarterReport/reportExport/${reportCode}`
}
// @ApiOperation(value = "机构季报-季报详情信息表文件上传信息保存", notes = "机构季报-季报详情信息表文件上传信息保存")
// @GetMapping("reportFileSave")
// // 季报信息表保存
export const reportFileSave = params => get(Header.client + `/quarterReport/reportFileSave`, params);


export const singleUploadQuarter = (formData, type, institutionName) => postFormData(Header.client + `/quarterReport/singleUpload/${type}`, formData);

//图片预览
export const imgSrcGetBase64 = filePath => get(Header.client + `/file/downloadPreviewBase64?filePath=${filePath}`);

export const uploadExcelToSave = (reportCode, reportType, formData) => postFormData(Header.client + `/quarterReport/uploadExcelToSave/${reportCode}/${reportType}`, formData);
//首页小镇简介
export const getTownList = () => get(Header.client + `/pageConfig/getPageList`);

export const dataSourceTemplate = reportType => { location.href = Header.download + `/quarterReport/dataSourceTemplate/${reportType}` };

//公共下载接口
export const commonDownload = params => {
    location.href = `${Header.download}/file/fileDownload?fileName=${params.fileName}&filePath=${params.filePath}`
}

//blob接口

export const getBlobPDF = filePath => getBlob(Header.client + `/file/downloadOutStream?filePath=${filePath}`);
//图片缓存接口

export const imgIndexDB = filePath => {
    return new Promise(
        (resolve, reject) => {
            let request = window.indexedDB.open("Client");
            let db;
            request.onerror = function (event) {
                console.log('数据库打开报错');
            };
            request.onsuccess = function (event) {
                db = request.result;
                console.log('数据库打开成功');
                read()
            };
            request.onupgradeneeded = function (event) {
                db = event.target.result;
                db.createObjectStore('img', { keyPath: 'imgPath' });
            }
            function add(result) {
                var request = db.transaction(['img'], 'readwrite')
                    .objectStore('img')
                    .add({ imgPath: filePath, imgBlob: result });

                request.onsuccess = function (event) {
                    console.log('数据写入成功', event);
                };

                request.onerror = function (event) {
                    console.log('数据写入失败', event);
                }
            }
            function update(result, res) {
                console.log("开始更新")
                var request = db.transaction(['img'], 'readwrite')
                    .objectStore('img')
                    .put({ ...result, ...{ imgBlob: res } });

                request.onsuccess = function (event) {
                    console.log('数据更新成功', event);
                };

                request.onerror = function (event) {
                    console.log('数据更新失败', event);
                }
            }
            function read() {

                var transaction = db.transaction(['img']);
                var objectStore = transaction.objectStore('img');
                var request = objectStore.get(filePath);

                request.onerror = function (event) {
                    console.log('事务失败');
                };

                request.onsuccess = function (event) {
                    var result = request.result;
                    if (result) {
                        console.log("读取成功", result)
                        const result1 = URL.createObjectURL(result.imgBlob);
                        resolve(result1)
                        getBlob(Header.client + `/file/downloadOutStream?filePath=${filePath}`).then(res => { update(result, res); });
                    } else {
                        console.log("读取失败", event)
                        getBlob(Header.client + `/file/downloadOutStream?filePath=${filePath}`).then(res => {
                            const result1 = URL.createObjectURL(res);
                            resolve(result1); add(res);
                        });
                    }
                };
            }
        }
    )
}